import { Controller } from "@hotwired/stimulus";

// Lightweight controller for dispatching global events.
// Attach to body or a high-level wrapper to enable cross-component communication.
export default class extends Controller {
  dispatchFiltersOpen() {
    document.dispatchEvent(new CustomEvent("filters:open"));
  }
}
